import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import './DetailHeader.scss';
import useDeviceScroll from 'src/hooks/useDeviceScroll';
import DetailHeaderContext from './Context/DetailHeader.context';
import LottoDraw from './Components/LottoDraw';
import RacingDetail from './Components/RacingDetail';
import AllMarkets from './Components/AllMarkets';

interface DetailHeaderProps {
  children?: React.ReactNode
}

export default function DetailHeader({ children }: DetailHeaderProps) {
  const [showInfo, setShowInfo] = useState(false);
  const scrolled = useDeviceScroll();

  const context = { showInfo, setShowInfo, scrolled };

  useEffect(() => {
    if (showInfo) {
      setShowInfo(false);
    }
  }, [scrolled]);

  return (
    <div className={
      classNames({
        'detail-header__number-header': true,
        'detail-header__number-header--info': showInfo
      })
    }
    >
      <DetailHeaderContext.Provider value={ context }>
        { children }
      </DetailHeaderContext.Provider>
    </div>
  );
}

DetailHeader.LottoDraw = LottoDraw;
DetailHeader.RacingDetail = RacingDetail;
DetailHeader.AllMarkets = AllMarkets;
